/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dull_Main_Gorilla_WaveInputs */

const en_dull_main_gorilla_wave = /** @type {(inputs: Dull_Main_Gorilla_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted answers`)
};

const de_dull_main_gorilla_wave = /** @type {(inputs: Dull_Main_Gorilla_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgegebene Antworten`)
};

/**
* | output |
* | --- |
* | "Submitted answers" |
*
* @param {Dull_Main_Gorilla_WaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dull_main_gorilla_wave = /** @type {((inputs?: Dull_Main_Gorilla_WaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dull_Main_Gorilla_WaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dull_main_gorilla_wave(inputs)
	return de_dull_main_gorilla_wave(inputs)
});